/**
 * @generated SignedSource<<c6284f3fadf13845d59aee7fccd30c7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EngageContainerQuery$variables = {
  id: string;
};
export type EngageContainerQuery$data = {
  readonly brand: {
    readonly featureFlags: {
      readonly dailyDealEnabled: boolean;
      readonly interstitialNotificationsEnabled: boolean;
    };
    readonly finishedOnboarding: boolean;
    readonly isForumEnabled: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"AppClipTabContainer_brand">;
  };
  readonly user: {
    readonly isInternal: boolean;
  } | null;
};
export type EngageContainerQuery = {
  response: EngageContainerQuery$data;
  variables: EngageContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedOnboarding",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isForumEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "FeatureFlagsType",
  "kind": "LinkedField",
  "name": "featureFlags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interstitialNotificationsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dailyDealEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EngageContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppClipTabContainer_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EngageContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppClipsEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c498ec9e73978812096b48afb1d5faf9",
    "id": null,
    "metadata": {},
    "name": "EngageContainerQuery",
    "operationKind": "query",
    "text": "query EngageContainerQuery(\n  $id: ID!\n) {\n  user {\n    isInternal\n    id\n  }\n  brand(id: $id) {\n    finishedOnboarding\n    isForumEnabled\n    featureFlags {\n      interstitialNotificationsEnabled\n      dailyDealEnabled\n    }\n    ...AppClipTabContainer_brand\n    id\n  }\n}\n\nfragment AppClipTabContainer_brand on BrandType {\n  id\n  appConfig {\n    id\n    iosAppClipsEnabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "18b859ebef5d1fa6ade87842b7feb518";

export default node;
